/** React Query provider - shared query client provider. */

"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { PLATFORM_QUERY_DEFAULTS } from "@/lib/hooks/query-options";

let platformQueryClient: QueryClient | null = null;

export function createPlatformQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        ...PLATFORM_QUERY_DEFAULTS,
      },
    },
  });
}

export function getPlatformQueryClient(): QueryClient {
  if (!platformQueryClient) {
    platformQueryClient = createPlatformQueryClient();
  }
  return platformQueryClient;
}

/**
 * Query provider props.
 */
export interface QueryProviderProps {
  children: React.ReactNode;
}

/**
 * Query provider component - provides React Query context.
 *
 * @param children - Provider children
 * @returns Query provider component
 */
export function QueryProvider({ children }: QueryProviderProps) {
  const [queryClient] = useState(() => getPlatformQueryClient());

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
